import { render, staticRenderFns } from "./NoApp.vue?vue&type=template&id=4d2ec660&"
import script from "./NoApp.vue?vue&type=script&lang=js&"
export * from "./NoApp.vue?vue&type=script&lang=js&"
import style0 from "./NoApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports